import { Box } from 'grommet'
import styled from 'styled-components'

const MAX_WIDTH_CONTAINER = 332
const MAX_WIDTH_CONTAINER_TABLET = 220
const MAX_WIDTH_CONTAINER_MOBILE = 150

export const ExpertiseContentWrapper = styled(Box)`
  position: relative;

  .link-arrow {
    display: none;
  }

  .hexagon {
    display: none;
  }

  .card-container {
    justify-content: center;

    & > :nth-child(3n) {
      border-right: none;
    }

    & > :nth-last-child(-n + 3) {
      border-bottom: none;
    }
  }

  .container {
    align-items: center;
    border-bottom: 1px solid ${({ theme }) => theme.colors.secondary};
    border-right: 1px solid ${({ theme }) => theme.colors.secondary};
    display: flex;
    margin-bottom: ${({ theme }) => theme.spaces[0]};
    max-width: 453px;
    padding: ${({ theme }) => theme.spaces[4]}px;
    width: 100%;

    ${({ theme }) => theme.below.laptopL`
      max-width: ${MAX_WIDTH_CONTAINER}px;
    `}

    ${({ theme }) => theme.below.laptop`
        :nth-child(2),
        :nth-child(4),
        :nth-child(6) {
          border-right: none;
        }
        :nth-child(5),
        :nth-child(6) {
          border-bottom: none;
        }
        :nth-child(4){
          border-bottom: 1px solid ${theme.colors.secondary};
        }
        :nth-child(3){
          border-right: 1px solid ${theme.colors.secondary};
        }
    `}

    ${({ theme }) => theme.below.mobileS`
      border: none;
      :nth-child(3) {
        border-right: none;
      }
      :not(:last-child) {
        border-bottom: none;
      }
    `}

    ${({ theme }) => theme.below.laptopL`
      max-width: ${MAX_WIDTH_CONTAINER}px;
    `}

    ${({ theme }) => theme.below.tabletM`
      padding: ${({ theme }) => theme.newSpaces.xs}px;
      max-width: ${MAX_WIDTH_CONTAINER_TABLET}px;
    `}

    ${({ theme }) => theme.below.mobileXL`
      padding: ${theme.newSpaces.xs2}px;
      max-width: ${MAX_WIDTH_CONTAINER_MOBILE}px;
      margin: 0px;
    `}

    h3, span {
      font-size: ${({ theme }) => theme.fontSizes[5]}px;
      text-transform: none;
      ${({ theme }) => theme.below.tablet`
        text-transform: uppercase;
        font-size: ${theme.typography.mobile.title.title1.fontSize}px;
        line-height:  ${theme.newSpaces.md}px;
      `}
    }

    h3,
    p {
      align-self: center;
      text-align: center;
    }
  }
`
